import { createContext, useContext, useState } from 'react';

import LatestActivityService from 'domain/services/student/dashboard/latestActivity';
import usePagination from 'hooks/usePagination';

const LatestActivityContext = createContext(null);

export default function LatestActivityProvider({ children }) {
  const [latestActivityList, setLatestActivityList] = useState<any>([]);

  const { hasNext, hasPrev, currentPage, setCurrentPage, setTotalCount } = usePagination();

  async function getLatestActivity(action = 'same') {
    try {
      const results = await LatestActivityService.getStudentLatestActivity();
      setTotalCount(results.assignmentsTotalCount.aggregate.count);
      if (action === 'change') {
        setCurrentPage(1);
        setLatestActivityList([...results.grades, ...results.assignments]);
      } else {
        setLatestActivityList(prevState => [
          ...prevState,
          ...results.grades,
          ...results.assignments,
        ]);
      }
    } catch (err) {
      throw new Error(err);
    }
  }

  function queryMore() {
    const newPage = currentPage + 1;
    setCurrentPage(newPage);
    getLatestActivity('same');
  }

  function queryLess() {
    setCurrentPage(1);
    getLatestActivity('change');
  }

  return (
    <LatestActivityContext.Provider
      value={{
        hasPrev,
        hasNext,
        queryLess,
        queryMore,
        getLatestActivity,
        data: {
          latestActivityList,
        },
      }}
    >
      {children}
    </LatestActivityContext.Provider>
  );
}

export const useLatestActivity = () => useContext(LatestActivityContext);
